// Worthify i18n Translation System
// Each language lives in ./locales/<lang>.js — keep keys in sync with
// locales/en.js; missing keys fall back to English via useTranslation below.
import { en } from "./locales/en";
import { pl } from "./locales/pl";
import { de } from "./locales/de";
import { fr } from "./locales/fr";
import { es } from "./locales/es";

export const translations = { en, pl, de, fr, es };

// Translation hook
export const useTranslation = (language) => {
  const t = (key) => {
    const lang = translations[language] || translations.en;
    if (Object.prototype.hasOwnProperty.call(lang, key)) return lang[key];
    if (Object.prototype.hasOwnProperty.call(translations.en, key)) return translations.en[key];
    // Missing key → empty string so callers' `t(key) || fallback` patterns
    // work and raw key names never leak into the UI.
    return "";
  };
  return { t };
};

export default translations;
